module.exports = __webpack_public_path__ + "assets/icon-fav-deselected.ce991c18.svg";